import dtoToCriteria from './dtoToCriteria';
export function getOwnerForAccount(transferAccounts, accountId) {
    var _a;
    return (_a = transferAccounts.find(function (type) { return type.id === accountId; })) === null || _a === void 0 ? void 0 : _a.ownerId;
}
// inverse of ../to/transferToDto
export default function dtoToTransfer(tokens, feeFineTypes, locations, transferAccounts, stripes, intl) {
    var _a;
    return {
        conditions: ((_a = tokens.conditions) !== null && _a !== void 0 ? _a : []).map(function (_a) {
            var condition = _a.condition, account = _a.account;
            return ({
                condition: dtoToCriteria(condition, feeFineTypes, locations, stripes, intl),
                owner: getOwnerForAccount(transferAccounts, account),
                account: account,
            });
        }),
        else: {
            owner: getOwnerForAccount(transferAccounts, tokens.else.account),
            account: tokens.else.account,
        },
    };
}
